<template>
	<div>
		<!--支付提醒-->
		<el-alert :closable="false" :title="getHintDes" class="u-m-b-10" style="font-weight: bold" type="error"></el-alert>
		<el-row :gutter="20" justify="center" type="flex">
			<el-col
				v-for="({type, confirms = [], description = '', hasPayConfirm}, index) in getPayList"
				:key="index"
				:span="12">
				<el-card :header="type === 1 ? '在线支付' : '对公打款'" style="height: 450px">
					<el-row style="margin-bottom: 10px">
						<div>
							通过{{ type === 1 ? '线上付款' : '对公打款' }}的方式支付保费：
							<span class="red-bold">{{ totalPrice }}元</span>
						</div>
						<el-alert
							:closable="false"
							:title="description"
							class="u-m-t-5"
							style="font-weight: bold"
							type="warning"></el-alert>
					</el-row>
					<el-row v-if="confirms">
						<div v-for="(confirmItemDes, index1) in confirms" :key="index1" class="formView u-m-r-10">
							<el-checkbox v-model="confirmList[`${type}${index1}`]" style="font-weight: bold">
								<span v-html="`我已悉知：${removeP(confirmItemDes)}`"></span>
							</el-checkbox>
						</div>
					</el-row>
					<el-row justify="center" style="margin-top: 20px" type="flex">
						<el-button
							:disabled="isCanClick(type)"
							:loading="isPayLoading"
							size="medium"
							type="success"
							@click="onToPay(type, hasPayConfirm)">
							{{ type === 1 ? '在线支付' : '对公打款' }}
						</el-button>
					</el-row>
				</el-card>
			</el-col>
		</el-row>
		<DialogPayerInfo ref="payerInfo" @onPayerInfo="onPayerInfo"></DialogPayerInfo>
	</div>
</template>
<script>
import {canPayOffline} from '@/views/insuranceCenter/api/insureApiNew'
import {isLibaoGuzhu, isMeiYa} from 'meibao-insure/src/util/productUtil'
import DialogPayerInfo from 'meibao-insure/src/components/dialog/dialogPayerInfo.vue'

export default {
	name: 'choicePayType',
	components: {DialogPayerInfo},
	props: {
		isAdd: Boolean,
		totalPrice: String | Number,
		productId: String | Number,
		sourceProductId: String | Number,
		orderId: String,
		insureType: String | Number,
		payTypesData: {
			required: true,
			default: () => {
				return []
			},
		},
		isPayLoading: Boolean,
	},
	watch: {
		payTypesData: {
			handler(newVal) {
				if (!this.validatenull(newVal)) {
					//处理选择方式，生成确认的数据
					for (let i = 0; i < newVal.length; i++) {
						let {confirms = [], type} = newVal[i]
						for (let j = 0; j < confirms.length; j++) {
							this.$set(this.confirmList, `${type}${j}`, false)
						}
					}
				}
			},
			immediate: true,
		},
	},
	data() {
		return {
			paySource: -1,
			pollingCount: 0,
			confirmList: {},
			payOrderId: '',
			//美亚对象
			myPayerInfo: {},
			//是否有支付提醒特约
			hasPayConfirm: -1,
		}
	},
	computed: {
		getPayList() {
			if (isLibaoGuzhu(this.insureType) && this.totalPrice >= 20000) {
				//去除对公支付
				return this.payTypesData.filter(({type}) => type !== 1)
			}
			return this.payTypesData
		},
		getHintDes() {
			return this.isAdd
				? '请确认以上信息，如需修改请点击【返回】进行操作，信息提交后需要在批单管理-处理中重新提交订单。'
				: '请确认以上信息，如需修改请点击【返回】进行操作，信息提交后需要在操作与保全-待支付中重新提交订单。'
		},
	},

	methods: {
		isCanClick(paySource) {
			if (this.validatenull(this.confirmList)) {
				return true
			}
			let disabled = false
			for (let confirmListKey in this.confirmList) {
				if (confirmListKey.indexOf(`${paySource}`) === 0 && !this.confirmList[confirmListKey]) {
					disabled = true
				}
			}
			return disabled
		},
		//支付！！
		async onToPay(paySource = -1, hasPayConfirm = -1) {
			if (paySource !== -1) {
				this.paySource = paySource
			}
			if (this.paySource === 2) {
				this.$emit('update:isPayLoading', true)
				//对公支付
				let reqData = {pid: this.sourceProductId, npid: this.productId}
				if (this.orderId && this.isAdd) {
					reqData.orderId = this.orderId
				}
				try {
					let {
						data: {msg = '未知错误，请联系管理员', code = -1},
					} = (await canPayOffline(reqData, this.insureType)) || {}
					if (code === 0) {
						//准备数据进行支付！！！
						this.$emit('onToPay', {paySource: this.paySource})
					} else {
						throw msg
					}
				} catch (error) {
					this.$emit('update:isPayLoading', false)
					this.$alert(error, '提示', {
						confirmButtonText: '确定',
					}).then(() => {})
				}
			} else {
				//在线支付
				this.hasPayConfirm = hasPayConfirm
				if (isMeiYa(this.insureType) && this.validatenull(this.myPayerInfo)) {
					//美亚
					this.$refs.payerInfo.showDialog()
				} else {
					//直接支付
					this.onPayerInfo()
				}
			}
		},
		//美亚支付人信息数据
		onPayerInfo(formData = {}) {
			if (this.validatenull(formData)) {
				formData = this.myPayerInfo
			} else {
				this.myPayerInfo = formData
			}
			this.$emit('update:isPayLoading', true)
			//处理支付
			this.$emit('onToPay', {paySource: this.paySource, hasPayConfirm: this.hasPayConfirm, myPayerInfo: formData})
		},
		//去除 P标签
		removeP(str = '') {
			//如果包含P标签，则去除
			if (str.includes('<p>')) {
				return str.replace(/<p>/g, '').replace(/<\/p>/g, '')
			}
			return str
		},
	},
}
</script>

<style lang="scss" scoped>
.formView ::v-deep .el-checkbox__label {
	display: inline-grid;
	white-space: pre-line;
	word-wrap: break-word;
	line-height: 20px;
}
</style>
